module.exports = __webpack_public_path__ + "img/Rectangle_20P.a3ee35b1.png";